import cx from 'classnames'

import SharedStyles from '../ViewControls.module.scss'
import Styles from './Properties.module.scss'

import { BackButton } from '../common/BackButton/BackButton'

import { EditFolderProperty } from './EditFolderProperty'
import { EditDefaultProperty } from './EditDefaultProperty'
import { EditWorkspaceProperty } from './EditWorkspaceProperty'
import { EditWorkflowProperty } from './EditWorkflowProperty'

import { EditPropertyPadOptions, EditableProperty } from './Properties'

type Props = {
  editableProperty: EditableProperty
  visiblePad: EditPropertyPadOptions
  onBackButton: () => void
  onClose: () => void
  isRename?: boolean
}

const Components = {
  EditFolderProperty,
  EditDefaultProperty,
  EditWorkspaceProperty,
  EditWorkflowProperty,
}

export const EditPropertyContainer = ({
  editableProperty,
  visiblePad,
  onBackButton,
  onClose,
  isRename = false,
}: Props) => {
  const Editor = Components[visiblePad]

  return (
    <div className={cx(SharedStyles.control, Styles.propertiesControl)}>
      <div className={SharedStyles.title}>
        <BackButton onPress={onBackButton} /> Edit Property
      </div>
      <div className={SharedStyles.content}>
        <Editor editableProperty={editableProperty} onClose={onClose} isRename={isRename} />
      </div>
    </div>
  )
}
